export default __webpack_public_path__ + "static/media/40302.e10be770.jpg";